import {
    Box,
    Flex,
    Grid,
    Heading,
    Text
} from '@theme-ui/components'
import { Container, Markdown } from '~/Common'
import { useTranslation } from 'react-i18next'
import { formatCurrency, formatPercentage } from 'utils/helpers';
import { useResponsiveValue } from '@theme-ui/match-media';

export const UseOfFunds = ({ bg = 'white', data, container, ...props }) => {
    const { t } = useTranslation();
    const isMobile = useResponsiveValue([true, false, false, false]);
    const title = data?.title ?? null;
    const description = data?.description ?? null;
    const bottom = data?.bottom ?? null;
    const rows = data?.rows ?? null;
    const rowWidth = '600px';

    const hasMaxSubscription = rows && rows.some(row => row.max_value || row.max_percentage);

    return (
        <Box bg={bg} {...props}>
            <Container variant="layouts.section" {...container}>
                { title && <Heading as="h2" variant="content_block_heading">{t(title)}</Heading>}
                { description && <Box className="markdown" mb={[3,3,4]}>
                    <Markdown>{description}</Markdown>
                </Box>}

                {rows &&
                    <Box sx={{
                        position: 'relative',
                    }}>
                        <Box sx={{
                            overflowX: 'auto',
                        }}>
                            {!isMobile ? (
                                <>
                                    {hasMaxSubscription && (
                                        <Grid py={2} sx={{
                                            gridGap: 2,
                                            gridTemplateColumns: ['4fr 2fr 2fr'],
                                            width: '100%',
                                            minWidth: rowWidth,
                                            fontSize: '14px',
                                            textAlign: 'center'
                                        }}>
                                            <Box px={2}></Box>
                                            <Box px={2}>Minimum Subscription</Box>
                                            <Box px={2}>Maximum Subscription</Box>
                                        </Grid>
                                    )}
                                    <Grid py={2} sx={{
                                        gridGap: 2,
                                        gridTemplateColumns: hasMaxSubscription ? ['4fr 1fr 1fr 1fr 1fr'] : ['4fr 1fr 1fr'],
                                        width: '100%',
                                        minWidth: rowWidth,
                                        fontSize: '14px',
                                        textAlign: 'center'
                                    }}>
                                        <Box px={2}></Box>
                                        <Box px={2}>A$</Box>
                                        <Box px={2}>%</Box>
                                        {hasMaxSubscription && (
                                            <>
                                                <Box px={2}>A$</Box>
                                                <Box px={2}>%</Box>
                                            </>
                                        )}
                                    </Grid>

                                    <Box>
                                        {rows.map((row, key) => (
                                            <Grid key={key} py={'14px'} sx={{
                                                gridGap: 2,
                                                rowGap: 0,
                                                gridTemplateColumns: hasMaxSubscription ? ['8fr 2fr 2fr 2fr 2fr'] : ['8fr 2fr 2fr'],
                                                width: '100%',
                                                minWidth: rowWidth,
                                                borderTop: '1px solid #00000A',
                                                borderBottom: key === rows.length - 1 ? '1px solid #00000A' : 'none',
                                                bg: 'transparent',
                                                fontSize: '14px',
                                                textAlign: 'center',
                                                backgroundColor: row?.bg ? row.bg : 'transparent'
                                            }}>
                                                <Box sx={{textAlign: 'left'}} as="p" px={2}>{row?.title}</Box>
                                                <Box px={2}>{formatCurrency(row?.min_value, 0)}</Box>
                                                <Box px={2}>{formatPercentage(row?.min_percentage)}</Box>
                                                {hasMaxSubscription && (
                                                    <>
                                                        <Box px={2}>{formatCurrency(row?.max_value, 0)}</Box>
                                                        <Box px={2}>{formatPercentage(row?.max_percentage)}</Box>
                                                    </>
                                                )}
                                            </Grid>
                                        ))}
                                    </Box>
                                </>
                            ) : (
                                <>
                                    <Flex py={2} sx={{ flexDirection: 'column', width: '100%' }}>
                                        {rows.map((row, key) => (
                                            <Grid key={key} py={'14px'} sx={{
                                                maxWidth: '100%',
                                                borderTop: '1px solid #00000A',
                                                borderBottom: key === rows.length - 1 ? '1px solid #00000A' : 'none',
                                                bg: 'transparent',
                                                fontSize: '14px',
                                                textAlign: 'left',
                                                backgroundColor: row?.bg ? row.bg : 'transparent',
                                                rowGap: 1,
                                                columnGap: 2,
                                                gridTemplateColumns: '1fr 1fr',
                                            }}>
                                                <Box as="p" px={2} sx={{ gridColumn: 'span 2' }}>{row?.title}</Box>
                                                {hasMaxSubscription && (
                                                    <>
                                                        <Box ml={3} mt={1} px={2}>
                                                            <Text as="p" variant='smallLight'>{t('(Min Subscription)')}</Text>
                                                        </Box>
                                                        <Box mt={1} px={2}>
                                                            <Text as="p" variant='smallLight'>{t('(Max Subscription)')}</Text>
                                                        </Box>
                                                    </>
                                                )}
                                                <Box px={2} ml={hasMaxSubscription ? 3 : 0} mt={hasMaxSubscription ? 0 : 3} sx={{ textAlign: hasMaxSubscription ? 'left' : 'center' }}>{formatCurrency(row?.min_value, 0)}</Box>
                                                {hasMaxSubscription && (
                                                    <Box px={2}>{formatCurrency(row?.max_value, 0)}</Box>
                                                )}
                                                <Box px={2} ml={hasMaxSubscription ? 3 : 0} mt={hasMaxSubscription ? 0 : 3} sx={{ textAlign: hasMaxSubscription ? 'left' : 'center' }}>{formatPercentage(row?.min_percentage)}</Box>
                                                {hasMaxSubscription && (
                                                    <Box px={2}>{formatPercentage(row?.max_percentage)}</Box>
                                                )}

                                            </Grid>
                                        ))}
                                    </Flex>
                                </>
                            )}
                        </Box>
                    </Box>
                }

                { bottom && <Box mt={2} sx={{ fontSize: '14px' }} className="markdown">
                    <Markdown externalLinks={true}>{bottom}</Markdown>
                </Box> }
            </Container>
        </Box>
    )
};
